const BillingView = (function () {
  const credit_card_form_selector = '#credit_card_form';
  const paypal_form_selector = '#paypal_form';
  const billing_method_form_selector = '#billing_method_form';
  const selected_billing_method_selector = 'input[name=\'billing_profile[displayed_billing_method]\']';
  const cc_collection_selector = '#cc-collection';

  function showPaypalBilling() {
    $(credit_card_form_selector).slideUp('fast');
    $(paypal_form_selector).slideDown('fast');
  }

  function showCreditCardBilling() {
    $(credit_card_form_selector).slideDown('fast');
    $(paypal_form_selector).slideUp('fast');
  }

  function onBillingPage() {
    return $(billing_method_form_selector).length !== 0;
  }

  function creditCardIsSelected() {
    return $(`${selected_billing_method_selector}:checked`).val() == 'credit_card';
  }

  function showSelectedBillingMethod() {
    if (creditCardIsSelected()) {
      showCreditCardBilling();
    } else {
      showPaypalBilling();
    }
  }

  function bindMethodSelectionEvent() {
    $(selected_billing_method_selector).click(() => {
      showSelectedBillingMethod();
    });
  }

  function init() {
    if (!onBillingPage()) { return; }
    bindMethodSelectionEvent();

    $(document).ready(() => {
      $.fancybox($(cc_collection_selector));
    });
  }

  return {
    init,
  };
}());

$(() => { BillingView.init(); });
